var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { position: "relative", height: "100%", padding: "15px" },
    },
    [
      _vm.currentItineraryPlanningRow && _vm.currentItineraryPlanningRow.theDay
        ? _c(
            "el-dialog",
            {
              attrs: {
                top: _vm.dialogTopMargin,
                title: "行程規劃資料",
                visible: _vm.currentItineraryPlanningRowVisible,
                width: "85%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.currentItineraryPlanningRowVisible = $event
                },
              },
            },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [_vm._v("行程設定")]),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            float: "right",
                            padding: "6px 15px",
                            "margin-left": "10px",
                          },
                          attrs: { type: "danger" },
                          on: {
                            click: function ($event) {
                              _vm.currentItineraryPlanningRowVisible = false
                            },
                          },
                        },
                        [_vm._v("關 閉")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tabs",
                    {
                      attrs: { type: "border-card" },
                      model: {
                        value: _vm.planningTab,
                        callback: function ($$v) {
                          _vm.planningTab = $$v
                        },
                        expression: "planningTab",
                      },
                    },
                    [
                      _vm.currentItineraryPlanningRow.theDay
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "精彩行程", name: "thisTimes" } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      staticClass: "itinerary",
                                      attrs: {
                                        disabled: true,
                                        "label-width": "130px",
                                        size: "mini",
                                        "label-position": "right",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出發時間" } },
                                        [
                                          _c("el-time-select", {
                                            attrs: {
                                              "picker-options": {
                                                start: "08:00",
                                                step: "00:10",
                                                end: "23:30",
                                              },
                                              format: "HH:mm",
                                              "value-format": "HH:mm",
                                              placeholder: "出發時間",
                                            },
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.departureTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "departureTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.departureTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "出發集合地點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.assemblingPlace,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "assemblingPlace",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.assemblingPlace",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "旅館名稱" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.hotelName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "hotelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.hotelName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "上午景點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.morningSights,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "morningSights",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.morningSights",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "下午景點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.afternoonAttractions,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "afternoonAttractions",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.afternoonAttractions",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "早餐" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.breakfast,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "breakfast",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.breakfast",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "午餐" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.lunch,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "lunch",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.lunch",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "晚餐" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.dinner,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "dinner",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.dinner",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form",
                                    {
                                      staticClass: "itinerary",
                                      attrs: {
                                        disabled: true,
                                        "label-width": "130px",
                                        size: "mini",
                                        "label-position": "right",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "晚間景點" } },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.eveningAttractions,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "eveningAttractions",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.eveningAttractions",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "預計返回旅館時間" },
                                        },
                                        [
                                          _c("el-time-select", {
                                            attrs: {
                                              "picker-options": {
                                                start: "08:00",
                                                step: "00:10",
                                                end: "23:30",
                                              },
                                              format: "HH:mm",
                                              "value-format": "HH:mm",
                                              placeholder: "預計返回旅館時間",
                                            },
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.returnHotelTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "returnHotelTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.returnHotelTime",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "本日行程注意事項" },
                                        },
                                        [
                                          _c("el-input", {
                                            model: {
                                              value:
                                                _vm.currentItineraryPlanningRow
                                                  .theDay.notesOnToday,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm
                                                    .currentItineraryPlanningRow
                                                    .theDay,
                                                  "notesOnToday",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentItineraryPlanningRow.theDay.notesOnToday",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("el-form-item", {
                                        attrs: { label: "行程手冊上傳" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.currentItineraryPlanningRow.thisTime
                        ? _c(
                            "el-tab-pane",
                            { attrs: { label: "行程規劃", name: "thisDays" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "overflow-y": "scroll",
                                    height: "500px",
                                  },
                                },
                                _vm._l(
                                  _vm.currentItineraryPlanningRow.thisTime.data,
                                  function (item, index) {
                                    return _c(
                                      "el-form",
                                      {
                                        key: index,
                                        staticClass: "itinerary",
                                        attrs: {
                                          disabled: true,
                                          inline: true,
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: { label: "", size: "mini" },
                                          },
                                          [
                                            _c("el-tag", [
                                              _vm._v("Day" + _vm._s(index + 1)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "widh-input",
                                            staticStyle: { width: "90%" },
                                            attrs: { label: "行程說明" },
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              {
                                                staticClass: "line",
                                                attrs: { span: 24 },
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "行程說明",
                                                  },
                                                  model: {
                                                    value: item.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.description",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentPositionData &&
      _vm.currentPositionData.records &&
      _vm.currentPositionData.records.length > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "定位足跡紀錄",
                visible: _vm.positionDialogVisible,
                top: "2%",
                width: "70%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.positionDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    height: "100%",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.currentPositionData.records,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "600px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4178052834
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "日期", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v(_vm._s(scope.row.date))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1531225394
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "left", label: "景點", width: "250" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.viewPointName)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3218238656
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "到達時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.startTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3779423219
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "離開時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.leaveTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          824829608
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "停留時間",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.dwellTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          89793029
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "北緯", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.lat
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [_vm._v(_vm._s(scope.row.lat))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1203890484
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "東經", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.lng
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [_vm._v(_vm._s(scope.row.lng))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3511418036
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "功能", width: "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.lat && scope.row.lng
                                  ? [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    icon: "el-icon-position",
                                                    type: "success",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.googleMap(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看Google地圖")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.currentChatData && _vm.currentChatData.charMsgInfos.length > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "與領隊聊天紀錄",
                visible: _vm.chatDialogVisible,
                top: "2%",
                width: "450px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.chatDialogVisible = $event
                },
              },
            },
            [
              _vm.currentChatData.leaderInfo
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        height: "100%",
                        padding: "10px",
                      },
                    },
                    [
                      _c("div", { staticClass: "center" }, [
                        _c("div", { staticClass: "chat" }, [
                          _c("div", { staticClass: "contact bar" }, [
                            _c("div", {
                              staticClass: "pic",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  _vm.currentChatData.leaderInfo.avatar +
                                  ")",
                              },
                            }),
                            _c("div", { staticClass: "name" }, [
                              _vm._v(
                                _vm._s(_vm.currentChatData.leaderInfo.name)
                              ),
                            ]),
                            _c("div", { staticClass: "seen" }, [
                              _vm._v(_vm._s(_vm.currentChatData.date)),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "messages", attrs: { id: "chat" } },
                            [
                              _c("div", { staticClass: "time" }, [
                                _vm._v("聊天紀錄"),
                              ]),
                              _vm._l(
                                _vm.currentChatData.charMsgInfos,
                                function (item, index) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: index,
                                        class: {
                                          message: true,
                                          "chat-user":
                                            item.from !=
                                            _vm.currentChatData.leaderInfo.name,
                                          "chat-leader":
                                            item.from ==
                                            _vm.currentChatData.leaderInfo.name,
                                        },
                                        staticStyle: { position: "relative" },
                                      },
                                      [
                                        item.from !=
                                        _vm.currentChatData.leaderInfo.name
                                          ? _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "chat-time-chat-user",
                                              },
                                              [_vm._v(_vm._s(item.time))]
                                            )
                                          : _vm._e(),
                                        item.chatType == 1
                                          ? _c("span")
                                          : _vm._e(),
                                        _vm._v(" " + _vm._s(item.msg) + " "),
                                        item.chatType == 2
                                          ? [
                                              item.fileInfo
                                                ? _c("el-image", {
                                                    staticStyle: {
                                                      width: "80px",
                                                    },
                                                    attrs: {
                                                      src: item.fileInfo.url,
                                                      fit: "fill",
                                                      "preview-src-list": [
                                                        item.fileInfo.url,
                                                      ],
                                                    },
                                                  })
                                                : _c("span", [
                                                    _vm._v("圖片加載失敗"),
                                                  ]),
                                            ]
                                          : _vm._e(),
                                        item.from ==
                                        _vm.currentChatData.leaderInfo.name
                                          ? _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "chat-time-chat-leader",
                                              },
                                              [_vm._v(_vm._s(item.time))]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "input" }, [
                            _c("i", { staticClass: "fas fa-camera" }),
                            _c("i", { staticClass: "far fa-laugh-beam" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  "【" +
                                    _vm.currentChatData.userInfo.name +
                                    "】與【" +
                                    _vm.currentChatData.leaderInfo.name +
                                    "】領隊聊天紀錄"
                                ) +
                                " "
                            ),
                            _c("i", { staticClass: "fas fa-microphone" }),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            top: _vm.dialogTopMargin,
            title: "說明會影片",
            visible: _vm.seminarMovieDialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.seminarMovieDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", width: "100%" } },
            [
              _c("video", {
                attrs: {
                  src: _vm.currentSeminarMovieUrl,
                  autoplay: "",
                  controls: "",
                },
              }),
            ]
          ),
        ]
      ),
      _vm.currentRow
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: "資料查看",
                visible: _vm.viewDataDialogVisible,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.viewDataDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      attrs: {
                        span:
                          _vm.currentRow.applyType == 1
                            ? 24
                            : _vm.currentRow.applyType == 1
                            ? 12
                            : 24,
                      },
                    },
                    [
                      _vm.currentRow && _vm.currentRow.applyType != 8
                        ? _c("el-alert", {
                            staticStyle: {
                              color: "#4b4b4b",
                              "margin-bottom": "10px",
                            },
                            attrs: {
                              title:
                                "自" +
                                _vm.currentRow.applyDates[0] +
                                "至" +
                                _vm.currentRow.applyDates[1] +
                                "，申請【" +
                                _vm.currentRow.applyTypeDesc +
                                "】資料共計：" +
                                _vm.viewData.length +
                                " 筆",
                              closable: false,
                              type: "warning",
                              effect: "dark",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative", height: "80%" },
                        },
                        [
                          _vm.currentRow.applyType == 8
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      staticStyle: { margin: "5px" },
                                      attrs: { type: "success" },
                                    },
                                    [_vm._v("審核說明")]
                                  ),
                                  _c("el-input", {
                                    staticStyle: { height: "20%" },
                                    attrs: {
                                      disabled: true,
                                      type: "textarea",
                                      rows: 20,
                                      value: _vm.successRemark,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 1
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "時間",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.buildDate) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3687967071
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "建立者",
                                      width: "130",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.buildUserName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      86551069
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "公告內容",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.data.bulletinBoard
                                                ? _c("el-tag", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("cuttingText")(
                                                          scope.row.data
                                                            .bulletinBoard
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _c(
                                                    "el-tag",
                                                    {
                                                      attrs: { type: "danger" },
                                                    },
                                                    [_vm._v("無內容")]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1325396211
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "查看",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm.currentRow.applyType == 1 &&
                                              scope.row.data.bulletinBoard
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            _vm.currentRow,
                                                            scope.row.data
                                                              .bulletinBoard
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看內容")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      879848931
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 2
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "時間",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.buildDate) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3687967071
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "建立者" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.buildUserName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      86551069
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "建議攜帶物品",
                                      width: "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm.currentRow.applyType == 2
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看攜帶物品紀錄")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3644393881
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 3
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "時間",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.buildDate) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3687967071
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "建立者" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.buildUserName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      86551069
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "查看說明會影片",
                                      width: "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm.currentRow.applyType == 3 &&
                                              scope.row.data.fileInfo &&
                                              scope.row.data.fileInfo.length >
                                                0 &&
                                              scope.row.data.fileInfo[0]
                                                .files &&
                                              scope.row.data.fileInfo[0].files
                                                .length > 0
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看說明會影片")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1503266639
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 4
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "日期" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-tag", [
                                                _vm._v(_vm._s(scope.row.date)),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2369769736
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "查看聊天紀錄",
                                      width: "400",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.charMsgInfos.length > 0
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "查看與領隊聊天紀錄"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      978101694
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 5
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "日期",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.date) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2797572233
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "時間",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.time) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1005093768
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "檔名",
                                      width: "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.fileName) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1993278076
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "大小",
                                      width: "110",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.size) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1643156568
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "查看導覽紀錄",
                                      width: "200",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-video-play",
                                                    type: "primary",
                                                    size: "mini",
                                                    disabled: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewReferenceData(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("點我播放")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3380654822
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 6
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "日期" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.date) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2797572233
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "景點數量",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-tag",
                                                { attrs: { type: "danger" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.records.length
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" 個景點 "),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      588023489
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "查看足跡紀錄",
                                      width: "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "mini",
                                                    disabled: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewReferenceData(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2679323603
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.currentRow.applyType == 7
                            ? _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.listLoading,
                                      expression: "listLoading",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    data: _vm.viewData,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "550px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "時間",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.buildDate) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3687967071
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "建立者" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.buildUserName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      86551069
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "每日行程",
                                      width: "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm.currentRow.applyType == 7
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "mini",
                                                        disabled: false,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewReferenceData(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看每日行程")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3529488535
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.viewDataDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentCarryRow
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: "攜帶物品異動紀錄",
                visible: _vm.carryDialogVisible,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.carryDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-right": "5px" },
                      attrs: { span: 12 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative", height: "80%" },
                        },
                        [
                          _c(
                            "el-alert",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: { type: "success", closable: false },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  "建議攜帶物品共 " +
                                    _vm.currentCarryRow.data.recommended.items
                                      .length +
                                    " 項"
                                )
                              ),
                            ]
                          ),
                          _vm.currentCarryRow.applyType == 2
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    size: "mini",
                                    data: _vm.currentCarryRow.data.recommended
                                      .items,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "600px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "品項" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.description)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1516911488
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-left": "5px" },
                      attrs: { span: 12 },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { position: "relative", height: "80%" },
                        },
                        [
                          _c(
                            "el-alert",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: { type: "error", closable: false },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  "必帶物品共 " +
                                    _vm.currentCarryRow.data.required.items
                                      .length +
                                    " 項"
                                )
                              ),
                            ]
                          ),
                          _vm.currentCarryRow.applyType == 2
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    size: "mini",
                                    data: _vm.currentCarryRow.data.required
                                      .items,
                                    border: "",
                                    fit: "",
                                    "highlight-current-row": "",
                                    height: "600px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "項次",
                                      width: "60",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "品項" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.description)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1516911488
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: "3%",
            title: "作業紀錄",
            visible: _vm.logDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.logDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { position: "relative", height: "80%" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.logs,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "500px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "日期", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.buildDate))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "狀態", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm._f("statusFilter")(
                                    scope.row.beforeStatus
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(scope.row.beforeStatusDesc))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "狀態(異)", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm._f("statusFilter")(
                                    scope.row.status
                                  ),
                                },
                              },
                              [_vm._v(_vm._s(scope.row.statusDesc))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "備註" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "作業人員", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.buildUserName)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.logDialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": _vm.formLabelWidth,
                    disabled:
                      _vm.form.status == 0 ||
                      _vm.form.status == 3 ||
                      _vm.form.status == 4
                        ? false
                        : true,
                  },
                },
                [
                  _vm.form.id
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "狀態" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm._f("statusFilter")(_vm.form.status),
                              },
                            },
                            [_vm._v(_vm._s(_vm.form.statusDesc))]
                          ),
                          _vm.form.status == 0
                            ? _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v("表單審核中，無法修改。"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "申請項目",
                        prop: "applyType",
                        rules: [
                          {
                            required: true,
                            message: "請選擇申請項目",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "", placeholder: "請選擇項目" },
                          on: { change: _vm.getTravelDateRangeInfoByTourNo },
                          model: {
                            value: _vm.form.applyType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "applyType", $$v)
                            },
                            expression: "form.applyType",
                          },
                        },
                        _vm._l(_vm.applyOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: "" + item.val, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "資訊需求團號",
                        prop: "applyTourNo",
                        rules: [
                          {
                            required: true,
                            message: "請填寫紀錄資訊需求團號",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      !_vm.form.status
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-tag",
                                {
                                  staticStyle: {
                                    height: "auto",
                                    "white-space": "break-spaces",
                                    "font-size": "14px",
                                  },
                                  attrs: { type: "warning" },
                                },
                                [_vm._v("選取後預設帶入班機起飛/回程時間")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tourNumbers.length > 0
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "請選擇團號",
                              },
                              on: {
                                change: _vm.getTravelDateRangeInfoByTourNo,
                              },
                              model: {
                                value: _vm.form.applyTourNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "applyTourNo", $$v)
                                },
                                expression: "form.applyTourNo",
                              },
                            },
                            _vm._l(_vm.tourNumbers, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: {
                                  label: "" + item.val,
                                  value: item.key,
                                },
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "資訊需求日期時間範圍",
                        prop: "applyDates",
                        rules: [
                          {
                            required: true,
                            message: "請選擇資訊需求日期時間範圍",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      !_vm.form.status
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-tag",
                                {
                                  staticStyle: {
                                    height: "auto",
                                    "white-space": "break-spaces",
                                    "font-size": "14px",
                                  },
                                  attrs: { type: "warning" },
                                },
                                [_vm._v("日期一律以台灣時間為基準")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-date-picker", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.dateInfoLoading,
                            expression: "dateInfoLoading",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          disabled: !_vm.form.applyTourNo,
                          type: "datetimerange",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm",
                          "range-separator": "至",
                          "start-placeholder": "開始日期",
                          "end-placeholder": "結束日期",
                        },
                        model: {
                          value: _vm.form.applyDates,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applyDates", $$v)
                          },
                          expression: "form.applyDates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.showUserOptionsApplyTypeIDs.includes(_vm.form.applyType)
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "資訊需求人物姓名",
                            prop: "applyUserID",
                            rules: [
                              {
                                required:
                                  _vm.showUserOptionsApplyTypeIDs.includes(
                                    _vm.form.applyType
                                  )
                                    ? true
                                    : false,
                                message: "請填寫紀錄資訊需求人物姓名",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.dateInfoLoading,
                                  expression: "dateInfoLoading",
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "請選擇旅客",
                              },
                              model: {
                                value: _vm.form.applyUserID,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "applyUserID", $$v)
                                },
                                expression: "form.applyUserID",
                              },
                            },
                            _vm._l(_vm.travelers, function (item) {
                              return _c("el-option", {
                                key: item.userID,
                                attrs: {
                                  label: "" + item.name,
                                  value: item.userID,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "applyDescription",
                        label: "發生經過",
                        rules: [
                          {
                            required: true,
                            message:
                              "請詳細填寫發生經過，以及需求何種紀錄為參考依據",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", [
                            _vm._v(
                              "請詳細填寫發生經過，以及需求何種紀錄為參考依據。"
                            ),
                          ]),
                          _c("el-input", {
                            attrs: {
                              id: "remarkAreaContent",
                              type: "textarea",
                              rows: 10,
                            },
                            model: {
                              value: _vm.form.applyDescription,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "applyDescription", $$v)
                              },
                              expression: "form.applyDescription",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("div"),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.form.status == 0 ||
              _vm.form.status == 3 ||
              _vm.form.status == 4
                ? _c(
                    "el-button",
                    {
                      staticStyle: { color: "#4b4b4b" },
                      attrs: { type: "warning" },
                      on: { click: _vm.saveData },
                    },
                    [_vm._v("儲 存")]
                  )
                : _vm._e(),
              _vm.form.status == 1
                ? _c(
                    "el-button",
                    { on: { click: _vm.cancelRecordRequestStatus } },
                    [_vm._v("取消申請")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    type:
                      _vm.form.status == 0 ||
                      _vm.form.status == 3 ||
                      _vm.form.status == 4
                        ? ""
                        : "danger",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.form.status == 0 ||
                        _vm.form.status == 3 ||
                        _vm.form.status == 4
                        ? "取 消"
                        : "關 閉"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.device == "mobile"
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.chatLoading,
                  expression: "chatLoading",
                },
              ],
              staticClass: "customerDialog",
              attrs: {
                top: _vm.dialogTopMargin,
                title: "客服訊息",
                visible: _vm.dialogMessageVisible,
                fullscreen: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogMessageVisible = $event
                },
              },
            },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card chat-window full-height",
                  attrs: {
                    "body-style": { height: "88%", "overflow-y": "scroll" },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.toUser.userName))])]
                  ),
                  _vm.filtered_list.length > 0
                    ? _vm._l(
                        _vm.filtered_list[0].messages,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "div",
                                      { staticClass: "chat-date" },
                                      [
                                        _c("el-tag", [
                                          _vm._v(_vm._s(item.date)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    _vm._l(
                                      item.charMsgInfos,
                                      function (d, ind) {
                                        return _c(
                                          "div",
                                          {
                                            key: ind,
                                            staticClass: "chat-receive",
                                          },
                                          [
                                            d.from != _vm.fromUser
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-container-from",
                                                  },
                                                  [
                                                    _c("div", [
                                                      d.chatType == 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "chat-content-form",
                                                              attrs: {
                                                                closable: false,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    d.msg
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      d.chatType == 2 &&
                                                      d.fileInfo &&
                                                      d.fileInfo.url
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c("el-image", {
                                                                staticStyle: {
                                                                  width:
                                                                    "100px",
                                                                  height:
                                                                    "100px",
                                                                },
                                                                attrs: {
                                                                  "preview-src-list":
                                                                    [
                                                                      d.fileInfo
                                                                        .url,
                                                                    ],
                                                                  src: d
                                                                    .fileInfo
                                                                    .url,
                                                                  fit: "cover",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "time-flag",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " + _vm._s(d.time)
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                            d.from == _vm.fromUser
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "chat-container-send",
                                                    staticStyle: {
                                                      "text-align": "right",
                                                    },
                                                  },
                                                  [
                                                    _c("div", [
                                                      d.isRead
                                                        ? _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "read-flag",
                                                            },
                                                            [_vm._v("已讀")]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "time-flag",
                                                        },
                                                        [_vm._v(_vm._s(d.time))]
                                                      ),
                                                      d.chatType == 1
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "chat-content-send",
                                                              attrs: {
                                                                closable: false,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    d.msg
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      d.chatType == 2 &&
                                                      d.fileInfo &&
                                                      d.fileInfo.url
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _c("el-image", {
                                                                staticStyle: {
                                                                  width:
                                                                    "100px",
                                                                  height:
                                                                    "100px",
                                                                },
                                                                attrs: {
                                                                  src: d
                                                                    .fileInfo
                                                                    .url,
                                                                  fit: "cover",
                                                                  "preview-src-list":
                                                                    [
                                                                      d.fileInfo
                                                                        .url,
                                                                    ],
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-input",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.chatLoading,
                    placeholder: "請輸入內容",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.sendMsg($event)
                    },
                  },
                  model: {
                    value: _vm.msg,
                    callback: function ($$v) {
                      _vm.msg = $$v
                    },
                    expression: "msg",
                  },
                },
                [
                  _c("el-button", {
                    attrs: {
                      slot: "append",
                      disabled: _vm.chatLoading,
                      icon: "el-icon-s-promotion",
                      type: "success",
                    },
                    on: { click: _vm.sendMsg },
                    slot: "append",
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          staticStyle: { height: "100%" },
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "客服", name: "1" } }, [
            _c("div", { staticClass: "full-height" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticStyle: { position: "relative", height: "90%" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "row-box full-height" },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "full-height",
                          attrs: { xs: 24, sm: 24, md: 14, lg: 14, xl: 14 },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                size: "mini",
                                data: _vm.customerComplaintList,
                                border: "",
                                height: "100%",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "項次",
                                  width: "60",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.$index + 1)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "團號" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(row.tourGroupNo)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "團名" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(row.travelName)),
                                        ]),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: {
                                                  "font-size": "14px",
                                                },
                                              },
                                              [
                                                _vm._v(" 出發 "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s("" + row.beginDate)
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" - 回程 "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s("" + row.endDate)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "APP使用者" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var row = ref.row
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(row.fromUserName)),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "查看內文" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.editCustomerComplaint(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.device == "desktop"
                        ? _c(
                            "el-col",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.chatLoading,
                                  expression: "chatLoading",
                                },
                              ],
                              staticClass: "full-height hidden-xs-only",
                              staticStyle: {
                                position: "relative",
                                height: "92%",
                              },
                              attrs: { span: 9, offset: 1 },
                            },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass:
                                    "box-card chat-window full-height",
                                  attrs: {
                                    "body-style": {
                                      height: "88%",
                                      "overflow-y": "scroll",
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.toUser.userName)),
                                      ]),
                                    ]
                                  ),
                                  _vm.filtered_list.length > 0
                                    ? _vm._l(
                                        _vm.filtered_list[0].messages,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            { key: index },
                                            [
                                              _c(
                                                "el-row",
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 24 } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "chat-date",
                                                        },
                                                        [
                                                          _c("el-tag", [
                                                            _vm._v(
                                                              _vm._s(item.date)
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-row",
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 24 } },
                                                    _vm._l(
                                                      item.charMsgInfos,
                                                      function (d, ind) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: ind,
                                                            staticClass:
                                                              "chat-receive",
                                                          },
                                                          [
                                                            d.from !=
                                                            _vm.fromUser
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "chat-container-from",
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      d.chatType ==
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "chat-content-form",
                                                                              attrs:
                                                                                {
                                                                                  closable: false,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.msg
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      d.chatType ==
                                                                        2 &&
                                                                      d.fileInfo &&
                                                                      d.fileInfo
                                                                        .url
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "el-image",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      width:
                                                                                        "100px",
                                                                                      height:
                                                                                        "100px",
                                                                                    },
                                                                                  attrs:
                                                                                    {
                                                                                      "preview-src-list":
                                                                                        [
                                                                                          d
                                                                                            .fileInfo
                                                                                            .url,
                                                                                        ],
                                                                                      src: d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                      fit: "cover",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "time-flag",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.time
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            d.from ==
                                                            _vm.fromUser
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "chat-container-send",
                                                                    staticStyle:
                                                                      {
                                                                        "text-align":
                                                                          "right",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      d.isRead
                                                                        ? _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "read-flag",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "已讀"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "time-flag",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              d.time
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      d.chatType ==
                                                                      1
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "chat-content-send",
                                                                              attrs:
                                                                                {
                                                                                  closable: false,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.msg
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      d.chatType ==
                                                                        2 &&
                                                                      d.fileInfo &&
                                                                      d.fileInfo
                                                                        .url
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              _c(
                                                                                "el-image",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      width:
                                                                                        "100px",
                                                                                      height:
                                                                                        "100px",
                                                                                    },
                                                                                  attrs:
                                                                                    {
                                                                                      src: d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                      fit: "cover",
                                                                                      "preview-src-list":
                                                                                        [
                                                                                          d
                                                                                            .fileInfo
                                                                                            .url,
                                                                                        ],
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _vm._e(),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.chatLoading,
                                    placeholder: "請輸入內容",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.sendMsg($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.msg,
                                    callback: function ($$v) {
                                      _vm.msg = $$v
                                    },
                                    expression: "msg",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      slot: "append",
                                      disabled: _vm.chatLoading,
                                      icon: "el-icon-s-promotion",
                                      type: "success",
                                    },
                                    on: { click: _vm.sendMsg },
                                    slot: "append",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.cctotal > 0,
                        expression: "cctotal > 0",
                      },
                    ],
                    attrs: {
                      layout: "prev, pager, next",
                      total: _vm.cctotal,
                      page: _vm.listQueryCC.page,
                      limit: _vm.listQueryCC.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listQueryCC, "page", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listQueryCC, "limit", $event)
                      },
                      pagination: _vm.getAgencyCustomerComplaint,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c("el-tab-pane", { attrs: { label: "紀錄資訊需求", name: "2" } }, [
            _c(
              "div",
              { staticClass: "full-height" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "filter-form",
                    attrs: { inline: true },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "查詢" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "輸入需求人姓名或旅遊團名稱" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.getList($event)
                            },
                          },
                          model: {
                            value: _vm.listQuery.qry,
                            callback: function ($$v) {
                              _vm.$set(_vm.listQuery, "qry", $$v)
                            },
                            expression: "listQuery.qry",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: {
                        "margin-top": "8px",
                        "margin-left": "5px",
                      },
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        circle: "",
                        disabled: _vm.listLoading,
                      },
                      on: { click: _vm.getList },
                    }),
                    _c("el-button", {
                      attrs: {
                        type: "warning",
                        circle: "",
                        icon: "el-icon-plus",
                        disabled: _vm.listLoading,
                      },
                      on: { click: _vm.addData },
                    }),
                    _c("el-button", {
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        type: "success",
                        loading: _vm.listLoading,
                        circle: "",
                        icon: "el-icon-refresh-left",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refresh()
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticStyle: { position: "relative", height: "80%" },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.listLoading,
                            expression: "listLoading",
                          },
                        ],
                        attrs: {
                          size: "mini",
                          data: _vm.list,
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                          height: "100%",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "項次",
                            width: "60",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "申請項目",
                            width: "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " + _vm._s(scope.row.applyTypeDesc) + " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "狀態",
                            width: "130",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm._f("statusFilter")(
                                          scope.row.status
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.statusDesc))]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "團號",
                            width: "280",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [_vm._v(_vm._s(row.applyTourNo))]),
                                  _c(
                                    "div",
                                    [
                                      _c("el-tag", [
                                        _vm._v(
                                          " " +
                                            _vm._s(row.applyTravelName) +
                                            " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "需求人姓名",
                            width: "130",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.applyUserName)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "申請時間範圍",
                            width: "280",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.applyBeginDate) +
                                        " - " +
                                        _vm._s(scope.row.applyEndDate)
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "編輯" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.status == 0 ||
                                          scope.row.status == 3 ||
                                          scope.row.status == 4
                                            ? "success"
                                            : "info",
                                        size: "mini",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editData(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.status == 0 ||
                                            scope.row.status == 3 ||
                                            scope.row.status == 4
                                            ? "編輯"
                                            : "查看"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "紀錄" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getRecordRequestLog(
                                            scope.row.id
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("紀錄")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "資料查看",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status == 2
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getRecordRequestApplyDoneData(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("資料查看")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0,
                      expression: "total > 0",
                    },
                  ],
                  attrs: {
                    layout: "prev, pager, next",
                    total: _vm.total,
                    page: _vm.listQuery.page,
                    limit: _vm.listQuery.limit,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "page", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }